// BasicHeader.js
import { Platform, StyleSheet, Text, View, TouchableOpacity, Image } from 'react-native'
import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { COLORS, FONTS } from '../../../utils'
import { MaterialIcons } from '@expo/vector-icons'

export default function BasicHeader({ title = "Subscription", onRefresh }) {
    const navigation = useNavigation()
    const LeftArrow = require("../../assets/images/whiteleftarrow.png");

    return (
        <View style={styles.header}>
            {/* Back Button */}
            <TouchableOpacity
                onPress={() => navigation.goBack()}
                style={styles.backButton}
            >
                <Image source={LeftArrow} style={styles.icon} />
            </TouchableOpacity>

            {/* Title */}
            <Text allowFontScaling={false} style={styles.title}>
                {title}
            </Text>

            {/* Right Refresh Icon */}
            {onRefresh && (
                <TouchableOpacity
                    onPress={onRefresh}
                    style={styles.rightButton}
                >
                    <MaterialIcons name="refresh" size={24} color={COLORS.white} />
                </TouchableOpacity>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    header: {
        backgroundColor: COLORS.primary,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        paddingHorizontal: 15,
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        height: Platform.OS === "web" ? 78 : 94,
        justifyContent: "center",
        paddingTop: Platform.OS !== "web" ? 47 : null,
    },
    backButton: {
        position: "absolute",
        left: 17,
        top: Platform.OS === "web" ? 30 : 55,
        padding: 5,
        zIndex: 10,
    },
    rightButton: {
        position: "absolute",
        right: 17,
        top: Platform.OS === "web" ? 30 : 55,
        padding: 5,
        zIndex: 10,
    },
    icon: {
        height: 24,
        width: 24,
        tintColor: COLORS.white,
    },
    title: {
        flex: 1,
        textAlign: "center",
        color: COLORS.white,
        fontSize: 22,
        fontFamily: FONTS.PoppinsSemiBold,
    },
})
